export default "__VITE_ASSET__D$T0Az8a__"